/* Imports */
import React from "react"
import { CardBasic, Grid } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const CardBasicPage = () => {
    const items = [
        {
            title: "Portrait",
            content: (
                <Grid col={2} gap="s">
                    <CardBasic title="Title" orientation="portrait" fajnyIcon="headphones-solid">
                        Content
                    </CardBasic>

                    <CardBasic title="Title" orientation="portrait" fajnyIcon="headphones-solid" to="#">
                        Content
                    </CardBasic>
                </Grid>
            ),
            code: '<CardBasic title="Title" orientation="portrait" fajnyIcon="headphones-solid">\n    Content\n</CardBasic>\n\n<CardBasic title="Title" orientation="portrait" fajnyIcon="headphones-solid" to="#">\n    Content\n</CardBasic>',
        },
        {
            title: "Landscape",
            content: (
                <Grid col={2} gap="s">
                    <CardBasic title="Title" orientation="landscape" icon="headphones-solid">
                        Content
                    </CardBasic>

                    <CardBasic title="Title" orientation="landscape" icon="headphones-solid" to="#">
                        Content
                    </CardBasic>
                </Grid>
            ),
            code: '<CardBasic title="Title" orientation="landscape" icon="headphones-solid">\n    Content\n</CardBasic>\n\n<CardBasic title="Title" orientation="landscape" icon="headphones-solid" to="#">\n    Content\n</CardBasic>',
        },
    ]

    const propsItems = [
        {
            name: "title",
            type: "String",
            example: "Contact us",
            required: "Yes",
        },
        {
            name: "to",
            type: "String",
            example: "/contact",
            required: "No",
        },
        {
            name: "orientation",
            type: "String",
            example: "landscape",
            possible: '"portrait" | "landscape"',
            default: "portrait",
            required: "No",
        },
        {
            name: "icon",
            type: "String",
            example: "mail",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "mail-solid",
            possible: commonProps.fajnyIcons,
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default CardBasicPage
